import React from 'react';

const ReceivePaymentSlipPage = React.lazy(() => import('pages/ReceivePaymentSlipCredit/pages/ListPage'));
const ReceivePaymentSlipAddPage = React.lazy(() => import('pages/ReceivePaymentSlipCredit/pages/AddPage'));
const ReceivePaymentSlipEditPage = React.lazy(() => import('pages/ReceivePaymentSlipCredit/pages/EditPage'));
const ReceivePaymentSlipCopyPage = React.lazy(() => import('pages/ReceivePaymentSlipCredit/pages/CopyPage'));
const ReceivePaymentSlipDetailPage = React.lazy(() => import('pages/ReceivePaymentSlipCredit/pages/DetailPage'));
const ReceivePaymentSlipAdjustmentPage = React.lazy(
  () => import('pages/ReceivePaymentSlipCredit/pages/AdjustmentPage'),
);

const BankSupervision = React.lazy(() => import('pages/ReceivePaymentSlipCredit/pages/BankSupervision'));

const receiveSlipRoute = [
  { path: '/bank-supervision', exact: true, name: 'Ngân hàng shop phụ trách', function: 'SL_BANK_ASSIGNED_STORE_VIEW', requireAssigned: true, component: BankSupervision },
  {
    path: '/receive-payment-slip-credit',
    exact: true,
    name: 'Thu chi ngân hàng',
    function: 'SL_RECEIVE_PAYMENT_CREDIT_VIEW',
    component: ReceivePaymentSlipPage,
  },
  {
    path: '/receive-payment-slip-credit/add',
    exact: true,
    name: 'Thêm mới chứng từ tiền gửi',
    function: 'SL_RECEIVE_PAYMENT_CREDIT_ADD',
    component: ReceivePaymentSlipAddPage,
  },
  {
    path: '/receive-payment-slip-credit/detail/:id',
    exact: true,
    name: 'Chi tiết chứng từ tiền gửi',
    function: 'SL_RECEIVE_PAYMENT_CREDIT_VIEW',
    component: ReceivePaymentSlipDetailPage,
  },
  {
    path: '/receive-payment-slip-credit/edit/:id',
    exact: true,
    name: 'Chỉnh sửa chứng từ tiền gửi',
    function: 'SL_RECEIVE_PAYMENT_CREDIT_EDIT',
    requireAssigned: true,
    component: ReceivePaymentSlipEditPage,
  },
  {
    path: '/receive-payment-slip-credit/adjust/:id',
    exact: true,
    name: 'Điều chỉnh chứng từ tiền gửi đã ghi sổ',
    function: 'SL_RECEIVE_PAYMENT_CREDIT_POSTED_ADJUST',
    requireAssigned: true,
    component: ReceivePaymentSlipAdjustmentPage,
  },
  {
    path: '/receive-payment-slip-credit/copy/:id',
    exact: true,
    name: 'Sao chép chứng từ tiền gửi',
    function: 'SL_RECEIVE_PAYMENT_CREDIT_ADD',
    component: ReceivePaymentSlipCopyPage,
  },
];

export default receiveSlipRoute;
